import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$1 } from './p-C78HRAnj.js';

const componentHeaderCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:var(--jw-theme-surface-level0-bg-color);border-bottom:1px solid var(--jw-theme-surface-border-border-color);box-sizing:border-box;color:var(--jw-theme-surface-text-description-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;font-weight:600;gap:1rem;letter-spacing:-.0004em;line-height:normal;line-height:1.25rem;padding:1rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiComponentHeader = /*@__PURE__*/ proxyCustomElement(class WuiComponentHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: '1417ff4b4ea1da61d8472f29be4214bacf9bea59' }, this.icon && h("wui-icon", { key: 'de428ac9718797eea122b04e7e0f3d14d8a8fb13', name: this.icon, size: "md" }), this.label && h("span", { key: '247e9d10b96b0e47822653535e6d021fded2489b' }, this.label), h("slot", { key: '0b2b10455991839ff731f70e5133d94d6a9716c0' })));
    }
    static get style() { return componentHeaderCss; }
}, [257, "wui-component-header", {
        "label": [1],
        "icon": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-component-header", "wui-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-component-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiComponentHeader);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiComponentHeader as W, defineCustomElement as d };
